import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { m as motion } from 'framer-motion'

const Polygon = ({ shape, fill }) => {
  const shapes = {
    heptagon:
      'M373.136 5.179a50.652 50.652 0 0144.624 0l276.8 136.545a46.853 46.853 0 0125.279 31.65l69.544 312.112a44.931 44.931 0 01-8.558 37.469L587.398 771.408a49.435 49.435 0 01-39.034 18.745H242.531a49.435 49.435 0 01-39.034-18.745L10.074 522.955a44.931 44.931 0 01-8.557-37.47L71.06 173.373a46.854 46.854 0 0125.279-31.65z',
    octagon:
      'M542.46.013c15.121 0 22.647 6.488 27.719 11.56l207.841 207.76c3.226 5.583 11.98 15.316 11.98 29.12v292.794a43 43 0 01-11.98 29.124L570.179 778.126c-8.147 8.147-14.782 11.56-27.719 11.56H247.54c-15.357 0-22.042-5.882-27.719-11.56L11.979 570.371A42.53 42.53 0 010 541.247V248.453c0-11.9 4.02-21.164 11.979-29.124L219.821 11.573C229.5 1.899 237.183.013 247.54.013z',
  }
  return (
    <motion.svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 790 790'>
      <defs>
        <clipPath id='a'>
          <path d='M0 0h790v790H0z'></path>
        </clipPath>
      </defs>
      <g
        clipPath={`url(${window.location.protocol}//${window.location.host}${window.location.pathname}#a)`}>
        <motion.path d={shapes[shape]} fill={fill} />
      </g>
    </motion.svg>
  )
}

Polygon.propTypes = {
  shape: PropTypes.string.isRequired,
  fill: PropTypes.string.isRequired,
}

export default memo(Polygon)
